import $ from 'jquery';
import SearchBlockManager from './search-block-manager';

var hashChanged = function() {
    var $links = $('.main-nav .links li').removeClass('active');
};

$(function() {
    SearchBlockManager.init('onClick={this.submit}');

    const hash = location.hash;
    if (hash && hash.length > 1) {
      if (hash == '#search-row') {
        setTimeout(() => {
          $('#wheel-search .dropdowns select').addClass('pulse');
        }, 500);
      }
    }
});



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/index.js
 **/